import { render, staticRenderFns } from "./TaxonomyList.vue?vue&type=template&id=e09537ae&scoped=true&"
import script from "./TaxonomyList.vue?vue&type=script&lang=js&"
export * from "./TaxonomyList.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyList.vue?vue&type=style&index=0&id=e09537ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09537ae",
  null
  
)

export default component.exports